<template>
	<div>


		<div class="lt_bgi">
			<div class="title">
				预警信息
			</div>
			<div class="yjbox">
				<div>
					<div style="color: #FF9D5B;">{{msg.warning_count}}</div>
					<div>预警总数</div>
				</div>
				<div>
					<div style="color: #FF3838;">{{msg.warning_status1}}</div>
					<div>未处理</div>
				</div>
				<div>
					<div style="color: #0DDFDF;">{{msg.warning_status2}}</div>
					<div>未处理</div>
				</div>
			</div>
			<div class="conb">
				<div v-for="(item,index) in list" :key="index">
					<div class="w_title">
						<div>{{item.plot_name}}·{{item.types_name}}</div>
						<div v-if="item.level==27" style="background-color: #07B195;">{{item.level_name}}</div>
						<div v-if="item.level==28"  style="background-color: #feaf82;">{{item.level_name}}</div>
						<div v-if="item.level==29" style="background-color: #edb2b2;">{{item.level_name}}</div>
						<div v-if="item.level==30"  style="background-color: #eb1b2e;">{{item.level_name}}</div>
					</div>
					<div class="w_ms">{{item.note}}</div>
					<div class="w_t">{{item.submitter_time}}</div>
				</div>
			</div>

		</div>




	</div>
</template>

<script>
	import {
		warning_statistics,
		index
	} from "../../api/home.js";
	import {
		Message
	} from 'element-ui';
	export default {

		data() {
			return {
				msg: {},
				list: []
			}
		},
		mounted() {
			this.get1()
			this.get2()
		},
		methods: {
			get1() {
				warning_statistics().then((res) => {

					if (res.code == 0) {
						this.msg = res.data
						console.log(this.msg)
					} else {
						Message.error(res.msg)

					}

				})
			},
			get2() {
				index().then((res) => {

					if (res.code == 0) {
						this.list = res.data

					} else {
						Message.error(res.msg)

					}

				})
			}
		}
	}
</script>

<style scoped lang="less">
	.lt_bgi {
		width: 28vw;
		height: 40vh;
		background-image: url(/src/assets/rt1.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		position: relative;
		

	}

	.title {

		font-family: Source Han Sans CN;
		font-weight: bolder;
		font-size: 18px;
		color: #FFFFFF;
		font-style: italic;
		background: linear-gradient(0deg, #B5FFDA 0%, #FFFFFF 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		position: absolute;
		left: 70px;
		top: 8px
	}

	.yjbox {
		width: 90%;
		position: absolute;
		top: 60px;
		left: 40px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.yjbox>div {


		width: 32%;

		height: 74px;
		background-image: url(/src/assets/rtt.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}

	.yjbox>div>div:nth-of-type(1) {
		font-family: PangMenZhengDao;
		font-weight: 600;
		font-size: 22px;

	}

	.yjbox>div>div:nth-of-type(2) {
		font-family: Source Han Sans CN;
		font-weight: 500;
		font-size: 16px;
		color: #CCEFEC;
	}

	.conb {
		position: absolute;
		top: 150px;
		left: 40px;
		width: 90%;
		height: 200px;
		
		overflow: hidden;
		overflow: auto;
		overflow-y: scroll;
	}

	.conb>div {
		width: 90%;
		height:70px;
		background-image: url(/src/assets/yj.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		margin-bottom: 10px;
		padding: 10px 10px 10px 20px;
	}

	.w_title {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.w_title>div:nth-of-type(1) {
		font-family: Source Han Sans CN;
		font-weight: 600;
		font-size: 16px;
		color: #11E5C0;
	}

	.w_title>div:nth-of-type(2) {
		width:60px;
		height: 22px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
		border-radius:5px;
		color: #fff;
		font-weight: 600;
	}

	.w_ms {
		width: 100%;
		font-family: Source Han Sans CN;
		font-weight: 500;
		font-size: 14px;
		color: #CCEFEC;
		margin-top:4px;
		white-space: nowrap;
		/* 禁止换行 */
		overflow: hidden;
		/* 隐藏溢出内容 */
		text-overflow: ellipsis;
		/* 显示省略号 */

	}

	.w_t {
		font-family: Source Han Sans CN;
		font-weight: 500;
		font-size: 14px;
		color: #CCEFEC;
		margin-top:4px;
	}
</style>